module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTIgOCI+CiAgPHBhdGggaWQ9IuWkmuinkuW9ol81MyIgZGF0YS1uYW1lPSLlpJrop5LlvaIgNTMiIGQ9Ik01LjIsMS4wNjdhMSwxLDAsMCwxLDEuNiwwbDQsNS4zMzNBMSwxLDAsMCwxLDEwLDhIMmExLDEsMCwwLDEtLjgtMS42WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIgOCkgcm90YXRlKDE4MCkiIGZpbGw9IiMwMDM2NzkiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solid-arrow-down.svg
// module id = gijb
// module chunks = 26